import React, { useContext, useEffect, useState, useMemo } from 'react'
import { HeaderMenu } from '../../components/HeaderMenu.comp'
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import LoginContext from '../../context/login_context/LoginContext';
import { set } from 'date-fns';
import { SaveNowDatosCalderaDiario } from '../../API/DatosCaldera/SaveNowDatosCalderaDiario.api';

export const DatosCalderaDiario = () => {

    const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);

    const [formItemsData, setFormItemsData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // Campos requeridos del formulario
    const requiredFields = [
        'vapor_caldera_sincal',
        'energia_caldera_sincal',
        'agua_alimentacion_caldera_sincal',
        'vapor_caldera_visa',
        'agua_alimentacion_caldera_visa',
        'gas_natural_caldera_visa',
        'agua_alimentacion_caldera_disel',
        'ablandador_1',
        'ablandador_3',
        'ablandador_4',
        'temperatura_agua_alimentacion',
        'gas_natural_grupo_condensador',
        'energia_circuito_alta_temperatura',
        'energia_circuito_baja_temperatura',
        'horometro_grupo_generador',
        'energia_neta_entrada_el_paico',
        'energia_bruta_generada'
    ];

    // Validar si todos los campos están completos
    const isFormValid = useMemo(() => {
        return requiredFields.every(field => {
            const value = formItemsData[field];
            return value !== undefined && value !== null && value !== '';
        });
    }, [formItemsData]);

    // FORMATEA LA HORA A LA LOCAL DE CHILE SIN PASA POR EL TIMESTAMP
    const formatTimeLocale = async (timestamp) => {
    const fecha = new Date(timestamp);
    const opciones = {
        timeZone: 'America/Santiago',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,  // Formato 24 horas
        hourCycle: 'h23' // Alternativa para forzar 24 horas
    };
    let formats = new Intl.DateTimeFormat('es-CL', opciones).format(fecha).split(" ");
    // retorna ["20260506", "2026-05-06", "18:41:42"]
    return [
        Number(formats[0].replace(",", "").split("-").reverse().join("")+""+formats[1].split(":").join("")),
        formats[0].replace(",", "").split("-").reverse().join("-"),
        formats[1]
    ];
    }

    const SaveTheData = async () => {
        setIsLoading(true);
        const ArrayFechas = await formatTimeLocale(new Date().getTime());
        // console.log(LoginState.user,timestamp, ConGasN, ConAguaCald, tAguaALim, DurAgua, CondAgua, PresCaldera, ConsVapor)
        let isValidado = confirm('Esta seguro de Guardar estos Datos?')
        if(isValidado){
            const resultado = Object.entries(formItemsData).map(([medidor, totalizador]) => ({
                medidor,
                totalizador:Number(totalizador),
                sensor: "m2",
                planta: "CALDERA - AGROINDUSTRIAL EL PAICO S.A.",
                timestamp: new Date().getTime(),
                fecha: ArrayFechas[1],
                hora: ArrayFechas[2],
                fechacodigo: ArrayFechas[0]
            }));
            // console.log(resultado)
            await SaveNowDatosCalderaDiario(resultado)  
            setFormItemsData({})     
            setIsLoading(false);     
        }else{
            alert('Los Datos NO se Guardaron!!')
        } 
    }
    

    return (
        <>
            <HeaderMenu Pag_Sel={'icalderadiario'} />
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 mt-3'>
                        <h3>Datos de Caldera</h3>
                        <h5>Registrar diariamente a las 08:00</h5>
                        <br/>
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Vapor Caldera Sincal(M.T)"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.vapor_caldera_sincal || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, vapor_caldera_sincal: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Energía Caldera Sincal(H.T)"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.energia_caldera_sincal || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, energia_caldera_sincal: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Agua Alimentacion Caldera Sincal"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.agua_alimentacion_caldera_sincal || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, agua_alimentacion_caldera_sincal: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Vapor Caldera VISA"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.vapor_caldera_visa || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, vapor_caldera_visa: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Agua Alimentacion Caldera VISA"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.agua_alimentacion_caldera_visa || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, agua_alimentacion_caldera_visa: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Gas Natural Caldera VISA"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.gas_natural_caldera_visa || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, gas_natural_caldera_visa: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Agua Alimentacion Caldera Disel"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.agua_alimentacion_caldera_disel || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, agua_alimentacion_caldera_disel: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Ablandador 1"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.ablandador_1 || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, ablandador_1: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Ablandador 3"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.ablandador_3 || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, ablandador_3: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Ablandador 4"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.ablandador_4 || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, ablandador_4: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Temperatura Agua Alimentacion"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.temperatura_agua_alimentacion || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, temperatura_agua_alimentacion: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Gas Natural Grupo Generador"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.gas_natural_grupo_condensador || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, gas_natural_grupo_condensador: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Energia Circuito Alta Temperatura"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.energia_circuito_alta_temperatura || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, energia_circuito_alta_temperatura: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Energia Circuito Baja Temperatura"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.energia_circuito_baja_temperatura || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, energia_circuito_baja_temperatura: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Horometro Grupo Generador"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.horometro_grupo_generador || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, horometro_grupo_generador: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Energia Neta Entrada a El Paico (isla)"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.energia_neta_entrada_el_paico || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, energia_neta_entrada_el_paico: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>
                    <div className='col-12 col-md-4 pb-3'>
                        <TextField
                            label="Energia Bruta Generada (180)"
                            id="outlined-start-adornment"
                            size='small'
                            type='number'
                            fullWidth
                            value={formItemsData.energia_bruta_generada || ''}
                            onChange={(e) => setFormItemsData({...formItemsData, energia_bruta_generada: e.target.value})}
                            // InputProps={{
                            //     endAdornment: <InputAdornment position="start">m³/h</InputAdornment>,
                            // }}
                            // helperText={ConGasN_bkp===''?null:"Dato por Validar: "+ConGasN_bkp+"m³/h"}
                        />
                    </div>

                    <div className='col-12 p-3 text-right'>
                        <button
                            className='btn btn-success'
                            onClick={()=>SaveTheData()}
                            disabled={!isFormValid || isLoading}
                        >Guardar Datos</button>
                        {!isFormValid && (
                            <small className='text-muted d-block mt-2'>
                                Por favor, complete todos los campos para habilitar el envío
                            </small>
                        )}
                    </div>
                </div>
            </div>
        </>
  )
}
